document.addEventListener("DOMContentLoaded", () => {
  (async () => {
    /*OLD     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*/
    /*NEW     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*/
    const accessToken = "b3fbf97252dff66117fab4ebb3671299";

    const shopUrl = window.Shopify.shop;

    const query = `
      {
          collections(first: 250) {
            edges {
              node {
                id
                title
                handle
                description
                updatedAt
              }
            }
          }
      }
      `;

    const data = await fetch(
      `https://${shopUrl}/api/2023-07/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": accessToken,
        },
        body: JSON.stringify({ query }),
      }
    );

    console.log(data);

    async function getData() {
      if (data.ok) {
        const getData = await data.json();
        return getData;
      } else {
        return null;
      }
    }
  })();
});
